module.exports = __webpack_public_path__ + "4b2a491429be27cea527eb2b307ad6e7.png";